import React from "react";
import classNames from "classnames";
import MuiButton from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";

const styles = {
  alert: {
    position: "absolute",
    top: "6px",
    right: "0px",
    width: 12,
    height: 12,
    border: "2px solid #eee",
    borderRadius: "50%",
    backgroundColor: "#45cf35"
  },
  lowercase: {
    textTransform: "lowercase"
  },
  capitalize: {
    textTransform: "capitalize"
  }
};

const Button = ({
  children,
  classes,
  alert = false,
  color = "primary",
  textTransform,
  className,
  ...props
}) => (
  <MuiButton
    color={color}
    {...props}
    className={classNames(
      {
        [classes[textTransform]]: textTransform && classes[textTransform]
      },
      className
    )}
  >
    {children}
    {alert && <span className={classes.alert} />}
  </MuiButton>
);

export default withStyles(styles)(Button);



// WEBPACK FOOTER //
// ./src/components/Buttons/Button.js